module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), _c('bank-account-changed-warning', {
    attrs: {
      "isVisible": _vm.isBankAccountChangedWarningVisible,
      "isAdminView": true
    },
    on: {
      "close": _vm.hideBankAccountChangedWarning,
      "goToUpcomingTransactions": _vm.handleGoToUpcomingTransactions
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      " + _vm._s(_vm.accountType) + " account\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })]), _vm._v(" "), _c('breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "breadcrumbsData": _vm.breadcrumbData
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.userDetailLoading ||
    _vm.accountUsersLoading ||
    _vm.isNotesSegmentLoading ||
    _vm.isFundingSourcesSegmentLoading ||
    _vm.preferencesSpinner ||
    _vm.isUpcomingTransactionsSegmentLoading ||
    _vm.isRepresentativesLoading ||
    _vm.beneficiariesSpinner) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title top-margin"
  }, [_vm._v("Account information")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('RestrictedSingleInput', {
    attrs: {
      "input": _vm.newAccountName,
      "limit": 40
    },
    on: {
      "inputUpdated": _vm.onNewAccountNameUpdate
    }
  }), _vm._v(" "), (_vm.newAccountName.trim().length === 0) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.formatDate(_vm.account.createdAt)) + " ")])])])]), _vm._v(" "), (_vm.account.investorSince) ? _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.account.investorSince) ? _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.account.investorSince) + " ")])])])]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.account.legacyUsername) + " ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "disabled": _vm.disableSubmitButton()
    },
    on: {
      "click": function($event) {
        _vm.showUpdateAccountConfirmationModal()
      }
    }
  }, [_vm._v("\n                      Submit account information\n                  ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.account.accountId) + " ")])])])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [(_vm.account.status == 'active') ? _c('p', {
    staticClass: "label label-success capitalize-text"
  }, [_vm._v(" " + _vm._s(_vm.account.status) + " ")]) : _vm._e(), _vm._v(" "), (_vm.account.status == 'pending') ? _c('p', {
    staticClass: "label label-warning capitalize-text"
  }, [_vm._v(" " + _vm._s(_vm.account.status) + " ")]) : _vm._e(), _vm._v(" "), (_vm.account.status == 'inactive') ? _c('p', {
    staticClass: "label label-danger capitalize-text"
  }, [_vm._v(" " + _vm._s(_vm.account.status) + " ")]) : _vm._e(), _vm._v(" "), (_vm.account.hasUserComments) ? _c('p', {
    staticClass: "label label-danger capitalize-text"
  }, [_vm._v(" Comments ")]) : _vm._e()])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.account.legacyCustomerNumber) + " ")])])])])])])])])]), _vm._v(" "), (_vm.accountRepresentatives !== undefined && _vm.account.primaryInvestorId) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('AccountRepresentatives', {
    attrs: {
      "accountId": _vm.accountId,
      "accountName": _vm.accountName,
      "accountType": _vm.accountType,
      "representatives": _vm.accountRepresentatives,
      "primaryInvestorId": _vm.account.primaryInvestorId
    },
    on: {
      "representativesLoadingStarted": _vm.setRepresentativesSpinnerOn,
      "representativesLoadingSucceed": _vm.setRepresentativesSpinnerOff,
      "representativesLoadingFailed": _vm.setRepresentativesSpinnerOff,
      "representativesUpdated": _vm.loadAccountInformation
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.beneficiaries !== undefined) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('AccountBeneficiaries', {
    attrs: {
      "beneficiaries": _vm.beneficiaries,
      "accountId": _vm.accountId
    },
    on: {
      "beneficiaryLoadingStarted": _vm.setBeneficiariesSpinnerOn,
      "beneficiaryLoadingSucceed": _vm.setBeneficiariesSpinnerOff,
      "beneficiaryLoadingFailed": _vm.setBeneficiariesSpinnerOff,
      "beneficiariesUpdated": _vm.loadAccountInformation
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('AccountNotes', {
    attrs: {
      "accountId": _vm.accountId,
      "displayAlertForUpcomingTransactionsWithAction": _vm.shouldUpcomingTransactionsWithActionsBeDisplayed,
      "displayAlertForUpcomingTransactionsWithNoAction": _vm.shouldUpcomingTransactionsWithNoActionsBeDisplayed,
      "disable-investment": _vm.user.disableInvestment
    },
    on: {
      "goToUpcomingTransactionsSegment": function($event) {
        _vm.goToSegment('upcoming-transactions-segment')
      },
      "notesLoadingFailed": _vm.setNotesSpinnerOff,
      "notesLoadingStarted": _vm.setNotesSpinnerOn,
      "notesLoadingSucceed": _vm.setNotesSpinnerOff,
      "redirectToNoteDetailsView": _vm.goToViewDetail,
      "redirectToPurchaseInvestmentNoteView": _vm.goToPurchaseInvestmentNote
    }
  })], 1)]), _vm._v(" "), (_vm.account.defaultFundingSourceId !== undefined) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "funding-sources-segment"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('AccountFundingSources', {
    attrs: {
      "accountId": _vm.accountId,
      "defaultFundingSourceId": _vm.userAccount.defaultFundingSourceId,
      "account": _vm.account
    },
    on: {
      "fundingSourcesLoadingFailed": _vm.setFundingSourceSpinnerOff,
      "fundingSourcesLoadingStarted": _vm.setFundingSourceSpinnerOn,
      "fundingSourcesLoadingSucceed": _vm.setFundingSourceSpinnerOff,
      "defaultFundingSourceUpdated": _vm.handleDefaultFundingSourceUpdated,
      "restart": _vm.loadAccountUsers,
      "showBankAccountChangedWarning": _vm.showBankAccountChangedWarning
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('AdminAccountDocuments')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "preferences-segment"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n            Preferences\n          ")]), _vm._v(" "), _c('SuccessAlert', {
    attrs: {
      "isVisible": _vm.isPreferencesSuccessMessageVisible,
      "message": _vm.preferencesSuccessMessage
    },
    on: {
      "hideSuccessAlert": _vm.hidePreferencesSuccessMessage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), (_vm.account.communicationPreference !== undefined) ? _c('AccountPreferences', {
    attrs: {
      "accountId": _vm.accountId,
      "communicationPreference": _vm.account.communicationPreference,
      "interestPreference": _vm.account.interestPreference,
      "paymentPreference": _vm.account.paymentPreference,
      "communication1099Preference": _vm.account.communication1099Preference,
      "communicationImpactReportPreference": _vm.account.communicationImpactReportPreference,
      "user": _vm.user,
      "redemptionRestriction": _vm.account.redemptionRestriction
    },
    on: {
      "impactPreferencesLoadingFailed": _vm.setPreferencesSpinnerOff,
      "impactPreferencesLoadingStarted": _vm.setPreferencesSpinnerOn,
      "impactPreferencesLoadingSucceed": _vm.setPreferencesSpinnerOff,
      "updateImpactPreferencesFailed": _vm.setPreferencesSpinnerOff,
      "updateImpactPreferencesStarted": _vm.setPreferencesSpinnerOn,
      "updateImpactPreferencesSucceed": _vm.displayImpactPreferenceSuccessfulNotification
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "upcoming-transactions-segment"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('UpcomingTransactions', {
    ref: "upcomingTransactions",
    attrs: {
      "accountId": _vm.accountId,
      "defaultFundingSourceId": _vm.userAccount.defaultFundingSourceId,
      "investorAccountIdentifier": _vm.userAccount.accountId
    },
    on: {
      "goToFundingSourcesSegment": function($event) {
        _vm.goToSegment('funding-sources-segment')
      },
      "hideAlertForUpcomingTransactions": _vm.hideUpcomingTransactionsAlerts,
      "showAlertForUpcomingTransactionsWithAction": _vm.displayUpcomingTransactionsWithActionAlert,
      "showAlertForUpcomingTransactionsWithNoAction": _vm.displayUpcomingTransactionsWithNoActionAlert,
      "upcomingTransactionsLoadingFailed": _vm.setUpcomingTransactionsSpinnerOff,
      "upcomingTransactionsLoadingStarted": _vm.setUpcomingTransactionsSpinnerOn,
      "upcomingTransactionsLoadingSucceed": _vm.setUpcomingTransactionsSpinnerOff
    }
  })], 1)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Account name:")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Date created:")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Investor since:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Legacy username:")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("ID:")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Status:")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Legacy customer number:")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bc3d7cf","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditJointAccount.vue
// module id = 2145
// module chunks = 1